import { Base } from '@.api/methods';
import { AuthContextValue } from '@/Services';

import { CreateClusterBody, FormSupportQuery, ListClusterDashboardStoresQuery, ListClustersQuery, ListClusterStoresQuery, UpdateClusterBody } from './requests';
import {
    ClusterDetailResponse,
    ClusterFormSupportResponse,
    CreateClusterResponse,
    ListClusterDashboardStoresResponse,
    ListClustersResponse,
    ListClustersStoresResponse,
    UpdateClusterResponse,
} from './responses';

export class ServiceProviderClustersApi extends Base {
    constructor(auth?: AuthContextValue | null) {
        super(auth, 'v2');
    }

    public getClusterDetail(spCluster: number) {
        this.setPath('sp-clusters');

        this.setId(spCluster);

        return this.getRequest<ClusterDetailResponse>();
    }

    public listClusters(query?: Partial<ListClustersQuery>) {
        this.setPath('sp-clusters');

        if (query) {
            this.setQuery(query);
        }

        return this.getRequest<ListClustersResponse>();
    }

    public formSupport(query?: Partial<FormSupportQuery>) {
        this.setPath('sp-clusters/form-support');

        if (query) {
            this.setQuery(query);
        }

        return this.getRequest<ClusterFormSupportResponse>();
    }

    public createCluster(body: CreateClusterBody) {
        this.setPath('sp-clusters');

        this.setData(body);

        return this.postRequest<CreateClusterResponse>();
    }

    public updateCluster(spClusterId: number, body: UpdateClusterBody) {
        this.setPath('sp-clusters');

        this.setId(spClusterId);

        this.setData(body);

        return this.putRequest<UpdateClusterResponse>();
    }

    public deleteCluster(spClusterId: number) {
        this.setPath('sp-clusters');

        this.setId(spClusterId);

        return this.deleteRequest<object>();
    }

    public listClusterStores(spClusterId: number, query?: Partial<ListClusterStoresQuery>) {
        this.setPath('sp-clusters');

        this.setId(`${spClusterId}/stores`);

        if (query) {
            this.setQuery(query);
        }

        return this.getRequest<ListClustersStoresResponse>();
    }

    public listClusterDashboardStores(spClusterId: number, query?: Partial<ListClusterDashboardStoresQuery>) {
        this.setPath('sp-clusters');

        this.setId(`${spClusterId}/dashboard-stores`);

        if (query) {
            this.setQuery(query);
        }

        return this.getRequest<ListClusterDashboardStoresResponse>();
    }
}
